// API Configuration
// HBRabbits

// Determine BASE_URL based on the domain
const getBaseUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    // return "http://localhost:5000/api/v1";
    return "https://cbrexqa-asfpgzb6gxc9ffax.canadacentral-01.azurewebsites.net/api/v1";
  } else if (hostname === "cbrexadmin.pages.dev") {
    return "https://cbrexqa-asfpgzb6gxc9ffax.canadacentral-01.azurewebsites.net/api/v1";
  } else {
    // Default fallback
    return "https://cbrexqa-asfpgzb6gxc9ffax.canadacentral-01.azurewebsites.net/api/v1";
  }
};

export const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  CORS_PROXIES: [
    "https://cors-anywhere.herokuapp.com/",
    "https://api.allorigins.win/raw?url=",
    "https://corsproxy.io/?",
  ],
};

// BASRUS
// export const CLOUDFLARE_CONFIG = {
//   ACCOUNT_ID: "2ddb54b9a392b4e89a1bedae18bd910a",
//   API_TOKEN: "FYFNVBJeADIHVAMuYK8shwJfR8kPe8sQan4e3FXG",
//   IMAGES_ENDPOINT:
//     "https://api.cloudflare.com/client/v4/accounts/2ddb54b9a392b4e89a1bedae18bd910a/images/v1",
//   STREAM_ENDPOINT:
//     "https://api.cloudflare.com/client/v4/accounts/2ddb54b9a392b4e89a1bedae18bd910a/stream",
// };

// CBREX
export const CLOUDFLARE_CONFIG = {
  ACCOUNT_ID: "53e6dabae145e9e880de8d5194e44bc5",
  API_TOKEN: "xovQszkj1KCxxRIOW2mUPRTciVBiauj7ebJFPz5T",
  IMAGES_ENDPOINT:
    "https://api.cloudflare.com/client/v4/accounts/53e6dabae145e9e880de8d5194e44bc5/images/v1",
  STREAM_ENDPOINT:
    "https://api.cloudflare.com/client/v4/accounts/53e6dabae145e9e880de8d5194e44bc5/stream",
};
